import Chart from 'react-apexcharts';

// ----------------------------------------------------------------------

// export { default as StyledChart } from './styles';

export { default as useChart } from './useChart';

export default Chart;
